export const getStrategy = async ({
  region,
  apiKey,
  appId
}) => {
  const response = await fetch(`https://personalization.${region}.algolia.com/1/strategies/personalization`, {
    headers: {
      'Content-Type': 'application/json',
      'X-Algolia-Application-Id': appId,
      'X-Algolia-API-Key': apiKey
    }
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch personalization strategy. Status: ${response.status}`);
  }
  const result = await response.json();
  return result;
};